import classnames from "classnames";
import { PRICE_LIST, exceptPrice } from "src/config/priceTypeList";
import { getProductInfo } from "src/utils/storage/product";
import "./SiteType.style.scss";
import { useProductFlags } from "src/hooks/recoil/useProductFlags";
import { useRouter } from "src/hooks/useRouter";
import { useTranslation } from "react-i18next";
import { IGetCashUserStatusRes } from "src/service/types/pay.type";
import CashApply from "src/components/Common/CashApply/CashApply";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { SetStateAction, useEffect } from "react";

interface ISiteTypeUIProps {
  payTerm: string;
  setIsShowFooter: React.Dispatch<SetStateAction<boolean>>;
  startService: (serviceType: string) => void;
  toggleMoreInfo: () => void;
  toggleMoreInfoOn: boolean;
  confirmTrial: boolean;
  checkConfirm: (type: string) => void;
  toggleModalNoticePaypal: (payType: string) => void;
  modal: any;
  payType: string;
  startPay: (payType: string) => void;
  payPlanInfo: any;
  isCashApply: boolean;
  userCashStatus: IGetCashUserStatusRes | undefined;
  showCashReqModal: () => void;
  hideCashReqModal: () => void;
  requestCashStatus: (status: string) => void;
  deleteCashReqMsg: string;
  showCashRequestDel: boolean;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const SiteTypeUI = ({
  payTerm,
  // handleChange,
  setIsShowFooter,
  startService,
  toggleMoreInfo,
  toggleMoreInfoOn,
  confirmTrial,
  checkConfirm,
  toggleModalNoticePaypal,
  modal,
  payType,
  startPay,
  payPlanInfo,
  isCashApply,
  userCashStatus,
  showCashReqModal,
  hideCashReqModal,
  requestCashStatus,
  deleteCashReqMsg,
  showCashRequestDel,
  handleChange,
}: ISiteTypeUIProps) => {
  // const [payPlanInfo, setPayPlanInfo] = useRecoilState(payPlanInfoAtom);
  const product = getProductInfo().key;
  const productName = getProductInfo().name;
  const producyKey = getProductFromSessionStorage();

  const { t } = useTranslation();
  const priceListTest = PRICE_LIST({ t });
  const { isOciProduct } = useProductFlags();
  const { goSitePromotion, lang } = useRouter();
  const exceptPriceList = priceListTest[product].filter(
    (item: any, index: number) => {
      // if (product === "eco" && lang === "en" && index > 2) return true;
      if (product === "fireside") return false;
      if (isOciProduct && item.key === "premium") return false;
      else return !exceptPrice[lang][product]?.includes(item.key);
    },
  );
  // console.log("exceptPriceList", exceptPriceList);
  // useEffect(() => {
  //   console.log("fsdf kkk", payPlanInfo);
  // }, [payPlanInfo]);
  useEffect(() => {
    // setTimeout(() => {
    setIsShowFooter(true);
    // }, 500);
  }, []);
  return (
    <>
      {isCashApply && userCashStatus ? (
        <div className="containerBox">
          <div className="container">
            <CashApply
              isCenter={true}
              userCashStatus={userCashStatus}
              showCashReqModal={showCashReqModal}
              hideCashReqModal={hideCashReqModal}
              requestCashStatus={requestCashStatus}
              deleteCashReqMsg={deleteCashReqMsg}
              showCashRequestDel={showCashRequestDel}
              handleChange={handleChange}
            />
          </div>
        </div>
      ) : (
        <div className="containerBox">
          <div className="container">
            <div className="type">
              <h3 className="type__title">
                {t("subscriptionType.shortTitle", {
                  0: productName,
                })}
              </h3>
              <p className="type__desc">
                {t("subscriptionType.shortsubTitle", {
                  0: productName,
                })}
              </p>
              <div
                className={`flex ${
                  // product !== "wrapsody" && lang !== "en"
                  //   ? "justify-space-between"
                  //   : "justify-content-evenly"

                  "justify-content-evenly"
                } flexflow-wrap wrapContents`}
              >
                {exceptPriceList?.map((item: any, index: number) => (
                  <div
                    // className={classnames(`flex-item box ${product}`, {
                    //   free: item.key === 'free'
                    // })}
                    key={`${item.key}-${index}`}
                    className={classnames(`flex-item box `, {
                      free: item.key === "free",
                    })}
                    style={{
                      width:
                        product === "wrapsody"
                          ? lang === "ko"
                            ? `${!isOciProduct ? "260px" : "30%"}` // wrapsody 국문
                            : `${!isOciProduct ? "40%" : "30%"}` // wrapsody 영문
                          : lang === "ko"
                            ? "30%" // eco 국문
                            : "30%", // eco 영문
                    }}
                  >
                    <div className="flex align-column">
                      <div className="flex-item text center">
                        <form className="form">
                          <h4 className="form-title">{item.name}</h4>
                          <h4 className="form-price">
                            {item.key === "free" ? (
                              t("subscriptionType.fee.free")
                            ) : item.key === "premium" ? (
                              t("subscriptionType.fee.premium")
                            ) : (
                              <>
                                {/* {getProductPrice(item.key).currency === "WON"
                                ? t("subscriptionType.fee.won")
                                : t(
                                    "subscriptionType.fee.dollar"
                                  )} */}
                                {lang === "ko"
                                  ? t("subscriptionType.fee.won")
                                  : t("subscriptionType.fee.dollar")}
                                {`${
                                  // parseInt(
                                  //   getProductPrice(item.key).userPerPriceYear
                                  // ).toLocaleString() ?? ""
                                  parseInt(
                                    // @ts-ignore
                                    payPlanInfo[producyKey][item.key][lang][
                                      "year"
                                    ],
                                  ).toLocaleString() ?? ""
                                }`}
                              </>
                              // <NumberFormatBase
                              //   value={getProductPrice(item.key).userPerPriceYear}
                              //   displayType={"text"}
                              //   // thousandSeparator={true}

                              //   prefix={
                              //     getProductPrice(item.key).currency === "WON"
                              //       ? t("subscriptionType.fee.won")
                              //       : t(
                              //           "subscriptionType.fee.dollar"
                              //         )
                              //   }
                              // />
                            )}
                          </h4>
                          <h4 className="form-price-desc">
                            <span className="text text--black text--13">
                              {item.subTitle}
                            </span>
                          </h4>
                          {product === "eco" && (
                            <h4 className="form-price-desc">
                              <span className="text text--gray text--11">
                                {item.subTitleDesc}
                              </span>
                            </h4>
                          )}
                          <h4 className="form-desc2">
                            <span className="text text--blackLt text--14">
                              {item?.subscription
                                ?.split("\n")
                                ?.map((i: any, index: number) => (
                                  <p key={index}>{i}</p>
                                ))}
                            </span>
                          </h4>
                          <div className={`priceLine ${product}`}></div>
                          {Array.from(Array(item.featuresCnt).keys()).map(
                            (item1: any, index1: number) => (
                              // <div
                              //   className={classnames(`form-item text left`, {
                              //     'mg mt-10': product !== 'wrapsody'
                              //   })}
                              // >
                              <div
                                className={classnames(
                                  `form-item text left mg mt-10`,
                                )}
                              >
                                <i className="icon_check_info mg mt--10 inline-block vertical-middle" />
                                <span className="inline-block vertical-middle mg ml-10 form-info-w">
                                  {t(
                                    "subscriptionType.terms." +
                                      product +
                                      "." +
                                      String(item.key) +
                                      "_" +
                                      (index1 + 1),
                                  )
                                    ?.split("\n")
                                    ?.map((i: any, index: number) => (
                                      <p key={index}>{i}</p>
                                    ))}
                                </span>
                              </div>
                            ),
                          )}
                        </form>
                      </div>
                      <div className="flex-item">
                        <div className="button text center">
                          <button
                            type="button"
                            onClick={() => startService(item.serviceType)}
                            className="btn btn-green"
                            // disabled={!checkConfirm(item.serviceType)}
                            title={`${
                              confirmTrial || item.serviceType !== "TRIAL"
                                ? ""
                                : t("subscriptionType.limitFreeTrial")
                            }`}
                          >
                            {t(
                              "subscriptionType.startSubscriptionBtn." +
                                product +
                                "." +
                                item.key,
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div
                className="moreGreen mouseHover"
                style={{ cursor: "pointer" }}
              >
                <a
                  onClick={() => toggleMoreInfo()}
                  style={{ cursor: "pointer" }}
                >
                  <span className="inline-block vertical-middle ">
                    {toggleMoreInfoOn
                      ? t("subscriptionType.hide")
                      : t("subscriptionType.showMore")}
                  </span>
                  <i
                    className={`${
                      toggleMoreInfoOn ? "icon_close_info" : "icon_more_info"
                    } mg ml-8`}
                  />
                </a>
              </div>
              <div className={`${toggleMoreInfoOn ? "block" : "none"}`}>
                <table className="tableMgnt">
                  <colgroup>
                    <col width={product === "eco" ? "300px" : "28%"} />
                    <col />
                    <col />
                    {/* <col width={product === "eco" ? "22%;" : "18%;"} />
                  <col width={product === "eco" ? "22%;" : "18%;"} /> */}
                    {!isOciProduct && (
                      <col width={product === "eco" ? "22%;" : "18%"} />
                    )}
                    {!isOciProduct && (
                      <col width={product === "eco" ? "" : "18%"} />
                    )}
                    {/* <col width={product === "eco" ? "" : ""} /> */}
                    {/* <col /> */}
                  </colgroup>
                  <thead>
                    <tr className="top bottom">
                      <th>
                        <span>
                          {t(`subscriptionType.keyFeatures.${product}.feature`)}
                        </span>
                      </th>
                      {exceptPriceList
                        // .filter(
                        //   (item1, index1) =>
                        //     !(product === 'wrapsody' && index1 === 0)
                        // )
                        .map((item: any, index: number) => (
                          <th className="center" key={index}>
                            <span>{item.name}</span>
                          </th>
                        ))}
                    </tr>
                  </thead>
                  <tbody>
                    {/* {product === "wrapsody" && ( */}
                    {product === "eco" && (
                      <tr className="bottom">
                        <td>
                          {t(
                            `subscriptionType.keyFeatures.${product}.feature_0`,
                          )}
                        </td>
                        <td className="center">
                          {t(
                            `subscriptionType.keyFeatures.${product}.feature_0_1`,
                          )}
                        </td>
                        <td className="center">
                          {t(
                            `subscriptionType.keyFeatures.${product}.feature_0_1`,
                          )}
                        </td>
                        {!isOciProduct && <td></td>}
                      </tr>
                    )}
                    <tr className="bottom">
                      <td>
                        {t(
                          `subscriptionType.keyFeatures.${product}.feature_${
                            product === "eco" ? "1" : "0"
                          }`,
                        )}
                      </td>
                      {exceptPriceList
                        // priceList[product]
                        // .filter(
                        //   (item1, index1) =>
                        //     !(product === 'wrapsody' && index1 === 0)
                        // )
                        .map((item: any) => (
                          <td className="center" key={item.key}>
                            {t(
                              "subscriptionType.keyFeatures.terms." +
                                item.key +
                                "_1",
                            )}
                          </td>
                        ))}
                    </tr>
                    {product === "eco" && (
                      <tr className="bottom">
                        <td>
                          {t(
                            `subscriptionType.keyFeatures.${product}.feature_2`,
                          )}
                        </td>
                        {exceptPriceList
                          // priceList[product]
                          // .filter(
                          //   (item1, index1) =>
                          //     !(product === 'wrapsody' && index1 === 0)
                          // )
                          .map((item: any) => (
                            <td className="center" key={item.key}>
                              {t(
                                "subscriptionType.keyFeatures.terms." +
                                  item.key +
                                  "_2",
                              )}
                            </td>
                          ))}
                      </tr>
                    )}
                    {/* )} */}
                    {Array.from(Array(29).keys()).map((item1, index1) =>
                      exceptPriceList.filter((type: any) =>
                        type?.moreFeatures?.includes(index1 + 1),
                      ).length > 0 ? (
                        <tr className="bottom" key={index1}>
                          <td>
                            {t(
                              `subscriptionType.keyFeatures.${product}.feature_` +
                                (index1 + 1),
                            )}
                          </td>
                          {/* {exceptPriceList
                  .filter(
                    (item1, index1) =>
                      !(product === 'wrapsody' && index1 === 0)
                  )
                  .map((item3, index3) => (
                    <td className="center">
                      {exceptPriceList[
                        product === 'wrapsody' ? index3 + 1 : index3
                      ].moreFeatures.includes(index1 + 1) && (
                        <i className="icon_check inline-block vertical-middle" />
                      )}
                    </td>
                  ))} */}
                          {exceptPriceList.map((item3: any, index3: number) => {
                            return (
                              <td className="center" key={item3.key}>
                                {item3?.moreFeatures?.includes(index1 + 1) && (
                                  <i className="icon_check inline-block vertical-middle" />
                                )}
                              </td>
                            );
                          })}
                        </tr>
                      ) : null,
                    )}
                    {product === "eco" && (
                      <tr className="bottom">
                        <td>
                          {t(`subscriptionType.keyFeatures.${product}.bottom`)}
                        </td>
                        {exceptPriceList
                          // .filter(
                          //   (item1, index1) =>
                          //     !(product === 'wrapsody' && index1 === 0)
                          // )
                          .map((item: any) => (
                            <td className="center" key={item.key}>
                              {item.upcCnt === -1 ? "" : item.upcCnt}
                              {item.upcCnt === 3
                                ? t("admin.stat.cnt")
                                : item.upcCnt > 3
                                  ? t("admin.stat.overCnt")
                                  : ""}
                            </td>
                          ))}
                      </tr>
                    )}
                    <tr className="bottom">
                      <th></th>
                      {exceptPriceList
                        // .filter(
                        //   (item1, index1) =>
                        //     !(product === 'wrapsody' && index1 === 0)
                        // )
                        .map((item: any, index: number) => (
                          <th className="center pd py-30" key={item.key}>
                            <span>{item.name}</span>
                            <div className="mg mt-15">
                              <button
                                type="button"
                                onClick={() => startService(item.serviceType)}
                                className="btn btn-green"
                                // disabled={!checkConfirm(item.serviceType)}
                                title={`${
                                  confirmTrial || item.serviceType !== "TRIAL"
                                    ? ""
                                    : t("subscriptionType.limitFreeTrial")
                                }`}
                              >
                                {t("common.startBtn")}
                              </button>
                            </div>
                          </th>
                        ))}
                    </tr>
                  </tbody>
                </table>
                {isOciProduct && (
                  <div className={`mg mt-10 moreGreen mouseHover`}>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        goSitePromotion({});
                      }}
                    >
                      <span className="inline-block vertical-middle">
                        {t("siteType.applicationBtn.premium")}
                      </span>
                    </a>
                  </div>
                )}
              </div>
            </div>

            {/* <Modal
            show={modal.confirmNoticePaypal}
            onHide={() => toggleModalNoticePaypal()}
            className="confirm__period"
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {t("subscriptionType.noticeMsg1")}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <FormGroup>
                <div>
                  <form className="form">
                    <div className="form-item">
                      <span className="form-item-title">
                        {t("common.alert.noticePaypal")}
                      </span>
                    </div>
                  </form>
                </div>
              </FormGroup>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-gray"
                onClick={() => startPay(payType)}
              >
                {t("subscriptionType.type." + payType)}
              </Button>
              <Button
                className="btn btn-green"
                onClick={() => startService("PROMOTION")}
              >
                {t("subscriptionType.type.premium")}
              </Button>
            </Modal.Footer>
          </Modal> */}
          </div>
        </div>
      )}
    </>
  );
};

export default SiteTypeUI;
